// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body-main-container{
    height: calc(100vh - 205px);
    overflow: auto;
}
.questionContainer div:first-child{
    width: 200px;
    display: flex;
    justify-content: center;
}
.customHeight .modal-dialog.modal-lg.modal-dialog-centered .modal-content{
    height: calc(100vh - 60px);
    overflow: auto;
}
.headerStyle{
    border-radius: 6px;
    background: var(--field-background);
    padding: 13px 0px;
}
.questionContainer div:nth-child(2){
    width: calc(100vw - 280px);
}
.questionContainer div:nth-child(3){
    width: 80px
}
.editButton{
    width: fit-content !important;
}
.questionContainer{
    display: flex;
    margin-bottom: 20px;
    justify-content: center;

}`, "",{"version":3,"sources":["webpack://./src/components/modals/editQuizQuestionModel/EditQuizQuestion.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,iBAAiB;AACrB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI;AACJ;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B","sourcesContent":[".body-main-container{\n    height: calc(100vh - 205px);\n    overflow: auto;\n}\n.questionContainer div:first-child{\n    width: 200px;\n    display: flex;\n    justify-content: center;\n}\n.customHeight .modal-dialog.modal-lg.modal-dialog-centered .modal-content{\n    height: calc(100vh - 60px);\n    overflow: auto;\n}\n.headerStyle{\n    border-radius: 6px;\n    background: var(--field-background);\n    padding: 13px 0px;\n}\n.questionContainer div:nth-child(2){\n    width: calc(100vw - 280px);\n}\n.questionContainer div:nth-child(3){\n    width: 80px\n}\n.editButton{\n    width: fit-content !important;\n}\n.questionContainer{\n    display: flex;\n    margin-bottom: 20px;\n    justify-content: center;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
